<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-basket</v-icon>{{$t('order.orders')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <PrinterForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PrinterForm from '../../components/printer/Form';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Printer';

const { mapFields } = createHelpers({
  getterType: 'printer/getField',
  mutationType: 'printer/updateField'
});

export default {
  name: 'PrinterCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    PrinterForm,
    Toolbar
  },
  data() {
    return {
      item: {
        quantity: 1
      },
      defaultvalues: {

      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),

  },
  methods: {
    ...mapActions('printer', ['create','upload', 'reset']),

  }

};
</script>
